import React, { useRef, useState } from "react";
// فرض بر این است که toPersianDigits را وارد کرده‌اید

export default function StylishVariantSelector({ product, selected, handleQuantityChange, toPersianDigits }) {
  const [selectedWeight, setSelectedWeight] = useState(product.variants[0]?.weight || "");

  const quantityInputRef = useRef(null);
  
  const activeVariant = product.variants.find((v) => v.weight === selectedWeight) || product.variants[0];
  const currentQuantity = selected[activeVariant?.weight] || "";

  const isPowder = activeVariant?.weight === "Powder";

  const handleWeightChange = (e) => {
    setSelectedWeight(e.target.value);
    setTimeout(() => {
      quantityInputRef.current?.focus();
    }, 0);
  };

  return (
    <div className="mt-5 w-full bg-slate-50/50 p-4 rounded-2xl border border-slate-200/80 shadow-sm backdrop-blur-sm">
      <label className="block text-xs font-semibold text-slate-500 mb-2 mr-1">
        انتخاب وزن و تعداد
      </label>

      <div className="flex items-center gap-2">
        {/* Dropdown شیک انتخاب وزن */}
        <div className="relative flex-1">
          <select
            value={selectedWeight}
            onChange={handleWeightChange}
            className="w-full appearance-none bg-white border border-slate-200 text-slate-800 text-sm font-thin rounded-xl px-4 py-2 pl-10 cursor-pointer shadow-sm focus:outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20 transition-all duration-200 hover:border-slate-300"
          >
            {product.variants.map((variant) => (
              <option key={variant.weight} value={variant.weight}>
                {variant.label}
              </option>
            ))}
          </select>

          {/* آیکون فلش اختصاصی برای Dropdown */}
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center px-3 text-slate-400">
            <svg className="w-4 h-4 fill-current" viewBox="0 0 20 20">
              <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
            </svg>
          </div>
        </div>

        {/* ورودی تعداد با استایل Pill اختصاصی */}
        <div className="relative w-28 flex items-center">
          <input
            type="text"
            ref={quantityInputRef}
            inputMode="numeric"
            placeholder={isPowder ? "۱۰۰گرم" : "تعداد"}
            value={currentQuantity ? toPersianDigits(String(currentQuantity)) : ""}
            onChange={(e) => handleQuantityChange(activeVariant.weight, e.target.value)}
            className="w-full bg-white border border-slate-200 text-slate-900 text-sm font-bold text-center rounded-xl py-2 px-2 shadow-sm focus:outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20 transition-all duration-200 placeholder:text-slate-400 placeholder:font-normal"
          />
          {currentQuantity > 0 && (
            <span className="absolute left-2 text-[10px] font-medium text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded-md border border-amber-200/50">
             {isPowder ? "گرم" : "عدد"}
            </span>
          )}
        </div>
      </div>
  
    </div>
  );
}